import React from "react";
import { Plane } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { PARTNERS } from "@/lib/siteData";

const AIRLINES = ["Emirates", "Qatar Airways", "Turkish Airlines", "Ethiopian Airlines", "flydubai", "Kenya Airways", "Airlink"];

export const PartnersMarquee = () => (
  <section className="py-24 lg:py-28 bg-white border-y border-[#E5E7EB] overflow-hidden" data-testid="partners-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading eyebrow="Airline Partners" title="Airlines & travel suppliers we work with" subtitle="Trusted carriers, hotel groups and payment partners behind every Makchester booking." />
      <div className="flex flex-wrap justify-center gap-3 mb-12">
        {AIRLINES.map((a) => (
          <span key={a} className="inline-flex items-center gap-2 rounded-full border border-[#E5E7EB] bg-[#F9FAFB] px-5 py-2.5 text-sm font-semibold text-[#0A2E4D] hover:border-[#D4A62A] transition-colors" data-testid={`airline-chip-${a.toLowerCase().replace(/\s+/g, "-")}`}>
            <Plane size={14} className="text-[#D4A62A]" /> {a}
          </span>
        ))}
      </div>
    </div>
    <div className="relative">
      <div className="flex w-max mk-marquee">
        {[...PARTNERS, ...PARTNERS].map((p, i) => (
          <span key={i} className="mx-8 font-serif-display text-xl lg:text-2xl text-[#0A2E4D]/40 whitespace-nowrap select-none hover:text-[#D4A62A] transition-colors">{p}</span>
        ))}
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
    </div>
  </section>
);
